




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import AppConstants from '@/models/Apps/AppConstants';


@Component({
  name: 'GiganautAppIcon',
})
export default class extends GiganautVue {

	@Prop({required: true})
	appId: string;
	
	get isMobileApp() {
		if (this.appId === AppConstants.AppGiganautWorkerIosId || this.appId === AppConstants.AppGiganautWorkerAndroidId) {
			return true;
		}
		return false;
	}

	get appOsIcon() {
		if (this.appId === AppConstants.AppGiganautWorkerIosId) {
			return this.IconConstants.Ios;
		}
		if (this.appId === AppConstants.AppGiganautWorkerAndroidId) {
			return this.IconConstants.Android;
		}
		if (this.appId === AppConstants.AppGiganautWebPortalId) {
			return this.IconConstants.Web;
		}
		return "";
	}
	
}
